export const FB_IMAGE_WIX =
  "https://static.wixstatic.com/media/8f0bbb_147b87f18e5c4be1a7b67ee82b8a7e46~mv2.png/v1/fill/w_110,h_112,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/Calendar.png";

export const DEFAULT_PROFILE_IMAGE =
  "https://static.wixstatic.com/media/8f0bbb_3023e64f702d4fb39de64713d35853ad~mv2.png";
